const handlers = {
  handleInitialLetters: char => {
    if (/[a-zA-Z]/.test(char)) {
      return char.toUpperCase();
    }

    return '';
  },
  handleFirstDigit: char => {
    if (/[0-9]/.test(char)) {
      return `-${char}`;
    }

    return '';
  },
  handleDigitOrLetter: char => {
    if (/[a-zA-Z0-9]/.test(char)) {
      return char.toUpperCase();
    }

    return '';
  },
  handleFinalDigits: char => {
    if (/[0-9]/.test(char)) {
      return char;
    }

    return '';
  },
  stop: () => ''
};

const getHandlerKey = count => {
  if (count < 3) return 'handleInitialLetters';
  if (count === 3) return 'handleFirstDigit';
  if (count === 4) return 'handleDigitOrLetter';
  if (count < 7) return 'handleFinalDigits';
  return 'stop';
};

const carPlateMask = value => {
  const cleanedValue = String(value).replace(/[^a-zA-Z0-9]/g, '');
  let maskedValue = '';
  let maskedCount = 0;

  for (let i = 0; i < cleanedValue.length; i += 1) {
    if (maskedValue.length >= 8) break;
    const handlerKey = getHandlerKey(maskedCount);
    const newPart = handlers[handlerKey](cleanedValue[i]);

    if (newPart) {
      maskedValue += newPart;
      maskedCount += 1;
    }
  }

  return maskedValue;
};

export default carPlateMask;